import React, {Component} from 'react'
import { Row, Col, FormControl, Modal, Form, FormGroup, Button } from 'react-bootstrap'
import { Checkbox, Radio } from 'react-icheck'
import PrintPreview from './PrintPreview'
import FontAwsome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
import WorkdocStore from '../../stores/WorkdocStore'

var NotificationSystem = require('react-notification-system');
const DEFAULT_ROW = 24
const DEFAULT_NEW_ROW = 2
class PrintKKCDamagePartCheckList extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,allData:[],data:[],showModalSearchGroup:false,checkOption:[{label:'ทั้งหมด',value:'all',checked:true}],checkAll:true,partCheckList:[],page_title:'กำลังดึงข้อมูล..',result:false}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
    this.loadWorkdocRelated()
  }

  loadData() {
    let checkOption = []
    checkOption.push({
      label:'ทั้งหมด',
      value:'all',
      checked:true
    })
    this.setState({loading:true})
    StockStore.loadPartItem(this.props.no,this.props.carType,(result)=>{
      result.data.list.forEach(function(item,index) {
        checkOption.push({
          label:item.description,
          value:item.group_main_id,
          checked:true
        })
      })
      this.setState({loading:false,showModalSearchGroup:true,allData:result.data.list,data:[],checkOption:checkOption})
    })
  }

  loadWorkdocRelated() {
    let {workNo} = this.props
    let {partCheckList} = this.state
    WorkdocStore.loadWorkdocRelated(workNo,'damagepart_doc',(result)=>{
      if (result.data.length>0&&result.data!==undefined) {
        let objPart = JSON.parse(result.data)
        this.setState({partCheckList:objPart.part_checkedlist,page_title:'ไม่พบข้อมูล',result:true})
      } else {
        this.setState({page_title:'ไม่พบข้อมูล',result:false})
      }
    }) 
  }
  
  // renderLogoUrl(logoUrl){
  //   let imgUrl = ''
  //   if (process.env.NODE_ENV == "development") {
  //     imgUrl = ''
  //   }else{
  //     imgUrl = ''
  //   }

  //   if(logoUrl!==undefined)
  //     return (<img src={imgUrl} />)
  //   else
  //     return ('')
  // }

  renderCompany() {
    return(
      [ 
        <header key={'h'}>
          <h2>{this.props.title}</h2>
        </header>,
        <article className={"article-company"} key={'a'}>
          
        </article>
      ]
    )
  }

  onPartClick(key,value,e) { 
    let {partCheckList} = this.state
    
    if (!value) {
      partCheckList.push(key)
    } else {
      let indexOf = partCheckList.indexOf(key)
      partCheckList.splice(indexOf,1)
    }
    this.setState({partCheckList:partCheckList})
    this.saveDamagePartDoc()
  }

  saveDamagePartDoc(action='') {
    let {partCheckList} = this.state
    let {workNo} = this.props
     
    let part_checkedlist = {part_checkedlist:partCheckList}
    WorkdocStore.saveWorkdocRelated(workNo,'damagepart_doc',part_checkedlist,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  renderRowData(item,index) {
    let {partCheckList} = this.state
    return(
      item.map((items,indexs) => {
        return(
            <div key={indexs}>
              <p><u className='kkc-check-list'>{items.description}</u></p>
              {
                items.sublist.map((itemss,indexss) => {
                  return(
                    <div key={indexss}>
                      <p className='kkc-check-list' style={{marginLeft:'15px'}}>{'- '+itemss.description}</p>
                      {
                        itemss.partlist.map((itemsss,indexsss) => {
                          let indexOf = partCheckList.indexOf(itemss.part_id[indexsss])
                          let value = indexOf!=-1 ? true : false
                          return(
                            <p className='kkc-check-list' key={indexsss} style={{marginLeft:'30px'}}>
                              <Checkbox
                                onChange={this.onPartClick.bind(this,itemss.part_id[indexsss],value)}
                                checked={indexOf!=-1 ? true : false}
                                checkboxClass="icheckbox_square-blue"
                                increaseArea="20%"
                                label={' '+itemsss}
                              >
                              </Checkbox>
                            </p>
                          )
                        })
                      }
                    </div>
                  )
                })
              }  
            </div>
        )    
      })      
    )
  }

  renderComponentPage(item,index) {
    return(
      <div className='font-print' key={index}>
        <div>
          {this.renderCompany()} 
        </div>
        <div style={{width:'100%'}}>
          <div style={{width:'50%',float:'left'}}>
            {this.renderRowData(item.left,index)}
          </div>  
          <div style={{width:'50%',float:'right'}}>
            {this.renderRowData(item.right,index)}
          </div>  
        </div>  
      </div>  
    )
  }

  getGroupSide(data) {
    let group = []
    let sublist = []
    let parts = []
    let sublists = []
    let part_id = []
    let parts_id = []

    let checkList = ''
    let checkSubList = ''
    data.data.forEach(function(item,index) {
      if (index===0||item.list!==checkList) {
        checkList = item.list
        checkSubList = item.sublist
        parts.push(item.parts)
        sublist.push(item.parts) // parts
        part_id.push(item.part_id)
        parts_id.push(item.part_id) // part_id
        sublists.push({
          sublist_id:item.sublist,
          description:item.sublist_description,
          partlist:sublist,
          part_id:parts_id
        })
        group.push({
          list_id:item.list,
          description:item.list_description,
          sublist:sublists
        })
        parts = []
        sublist = []
        sublists = []
        part_id = []
        parts_id = []
      } 
      else {
        if (item.list===checkList) {
          if (item.sublist===checkSubList) {
            let key_list = ''
            let key_sublist = ''
            group.forEach(function(gItem,gIndex) {
              if (gItem.list_id===item.list)
                key_list = gIndex

              gItem.sublist.forEach(function(subGItem,subGIndex) {
                if (subGItem.sublist_id===item.sublist)
                  key_sublist = subGIndex
              })
            })
            group[key_list].sublist[key_sublist].partlist.push(item.parts)
            group[key_list].sublist[key_sublist].part_id.push(item.part_id)
          } else {
            checkSubList = item.sublist
            parts.push(item.parts)
            sublist.push(item.parts) // parts
            part_id.push(item.part_id)
            parts_id.push(item.part_id) // part_id
            let key_list = ''
            group.forEach(function(gItem,gIndex) {
              if (gItem.list_id===item.list)
                key_list = gIndex
            })
            group[key_list].sublist.push({sublist_id:item.sublist,description:item.sublist_description,partlist:sublist,part_id:parts_id})
            parts = []
            sublist = []
            part_id = []
            parts_id = []
          }
        }
      }
    })
    return group
  }

  getGroup(data) {
    let allGroup = {left:{},right:{}}
    allGroup.left = this.getGroupSide(data.left)
    if (data.right.data!==undefined) {
      allGroup.right = this.getGroupSide(data.right)
    } else {
      allGroup.right = []
    }  

    return allGroup
  }

  getPagination(defaultSearch,checkAll,checkOption,data) {
    
    let checkRow = 0

    let newData = []
    let dataList = []
    let summaryData = []

    if (checkAll) {
      data.forEach(function(list,listIndex) {
        checkRow++
        list.sublist.forEach(function(sublist,sublistIndex) {
          if (sublist.partlist.length>0) {
            checkRow++
            sublist.partlist.forEach(function(partlist,partlistIndex) {

              if (checkRow<=DEFAULT_ROW) {
                dataList.push({
                  parts:partlist.description,
                  list:listIndex,
                  list_description:list.description,
                  sublist:sublistIndex,
                  sublist_description:sublist.description,
                  part_id:partlist.part_id
                })
                checkRow++
              }

              if (checkRow===DEFAULT_ROW-1||checkRow===DEFAULT_ROW) {
                newData.push({
                  data:dataList
                })
                dataList = []
                checkRow = DEFAULT_NEW_ROW
              }
            })
          }
        })
      })
    } else {
      let searchCase = []
      checkOption.forEach(function(item,index) {
        if (item.checked)
          searchCase.push(item.value)
      })

      data.forEach(function(list,listIndex) {
        if (searchCase.indexOf(list.group_main_id)!==-1) {
          checkRow++
          list.sublist.forEach(function(sublist,sublistIndex) {
            if (sublist.partlist.length>0) {
              checkRow++
              sublist.partlist.forEach(function(partlist,partlistIndex) {

                if (checkRow<=DEFAULT_ROW) {
                  dataList.push({
                    parts:partlist.description,
                    list:listIndex,
                    list_description:list.description,
                    sublist:sublistIndex,
                    sublist_description:sublist.description,
                    part_id:partlist.part_id
                  })
                  checkRow++
                }

                if (checkRow===DEFAULT_ROW-1||checkRow===DEFAULT_ROW) {
                  newData.push({
                    data:dataList
                  })
                  dataList = []
                  checkRow = DEFAULT_NEW_ROW
                }
              })
            }
          })
        }
      })
    }
    newData.push({
      data:dataList
    })
    dataList = []
    checkRow = 0
    let checkSide = 0
    let getIndex = 0
    let newDataSide = []
    newData.forEach(function(item,index) {
      if (checkSide===0) {
        newDataSide.push({
          left:item,
          right:{}
        })
        checkSide = 1
        getIndex = newDataSide.length-1
      } else {
        newDataSide[getIndex].right = item
        checkSide = 0
      }
    })

    let that = this
    newDataSide.forEach(function(item,index) {
      summaryData.push(that.getGroup(item))
    })
    return summaryData
  }

  onSearchGroupClick(e) {
    let {defaultSearch,checkOption,allData} = this.state
    let checkAll = false
    checkOption.forEach(function(item,index) {
      if (item.value==='all'&&item.checked===true)
        checkAll = true
    })
        
    this.setState({defaultSearch:defaultSearch,showModalSearchGroup:false,data:this.getPagination(defaultSearch,checkAll,checkOption,allData),checkAll:checkAll,checkOption:checkOption})
    
  }

  onCheckGroupChange(val,index,e) {
    let {checkOption} = this.state
    if (checkOption[index].checked) {
      if (val==='all') {
        checkOption.forEach(function(item,index) {
          checkOption[index].checked = false
        })
      } else {
        checkOption[index].checked = false
        checkOption[0].checked = false
      }  
    } else {
      if (val==='all') {
        checkOption.forEach(function(item,index) {
          checkOption[index].checked = true
        })
      } else {
        checkOption[index].checked = true
      }
    }
    this.setState({checkOption:checkOption})
  }

  renderCheckGroup() {
    let {checkOption} = this.state
    return(
      checkOption.map((item,index) => {
        return(
          <FormGroup key={index}>
            <Col sm={1}></Col>
            <Col sm={7}>
              <Checkbox
                onChange={this.onCheckGroupChange.bind(this,item.value,index)}
                checked={item.checked}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label={' '+item.label}
              >
              </Checkbox>
            </Col> 
          </FormGroup>  
        )
      })
    )
  }

  renderModalSearchGroup() {
    return(
        <Modal show={this.state.showModalSearchGroup} onHide={()=>this.setState({showModalSearchGroup:false})}>
          <Modal.Header closeButton>
            <Modal.Title>เลือกหมวดหมู่หลัก</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              {this.renderCheckGroup()}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.onSearchGroupClick.bind(this)}><FontAwsome name='save' />&nbsp;เลือกหมวดหมู่หลัก</Button>
            <Button style={{display:'none'}} onClick={()=>this.setState({showModalSearchGroup:false})}><FontAwsome name='close' />&nbsp;ปิด</Button>
          </Modal.Footer>
        </Modal>
    )
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.page_title}</h2>
        </header>
      </div>
    )
  }

  subRender() {
    let {loading,data,result} = this.state
    if (!result) {
      return(
        <div>
          <PrintPreview 
            loading={loading}
            leftBarTitle={this.props.title}
          >
            {this.renderNoData()}
          </PrintPreview>
        </div>  
      )
    } else {
      return(
        <div>
          <PrintPreview 
            loading={loading}
            leftBarTitle={this.props.title}
          >
            {
              data.map((item,index) => {
                return(
                  this.renderComponentPage(item,index)
                )
              })
            }
          </PrintPreview>
          {this.renderModalSearchGroup()}
        </div>  
      )
    }
  }

  render() {
    return(
      <div>
        {this.subRender()}
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintKKCDamagePartCheckList.defaultProps = {
  title: 'ใบตรวจเช็ครายการอะไหล่',  
  mode : '1'
}
export default PrintKKCDamagePartCheckList;


// WEBPACK FOOTER //
// ./src/view/print/PrintKKCDamagePartCheckList.js